export var ArcGisPropertyColumn;
(function (ArcGisPropertyColumn) {
    ArcGisPropertyColumn["Id"] = "OBJECTID";
    ArcGisPropertyColumn["ErfNumber"] = "ErfNo";
    ArcGisPropertyColumn["FarmNumber"] = "FarmNo";
    ArcGisPropertyColumn["Address"] = "Address";
    ArcGisPropertyColumn["Allotment"] = "Allotment";
    ArcGisPropertyColumn["PropertyDescription"] = "PropertyDescription";
    ArcGisPropertyColumn["PortionNumber"] = "PtnNum";
    ArcGisPropertyColumn["SGNumber"] = "SgCode";
    ArcGisPropertyColumn["PremiseId"] = "PremiseID";
    ArcGisPropertyColumn["AccountNumer"] = "AccountNo";
})(ArcGisPropertyColumn || (ArcGisPropertyColumn = {}));
export var ArcGisSectionalTitleColumn;
(function (ArcGisSectionalTitleColumn) {
    ArcGisSectionalTitleColumn["Id"] = "OBJECTID";
    ArcGisSectionalTitleColumn["ErfNumber"] = "ErfNo";
    ArcGisSectionalTitleColumn["FarmNumber"] = "FarmNo";
    ArcGisSectionalTitleColumn["Address"] = "Address";
    ArcGisSectionalTitleColumn["Allotment"] = "Allotment";
    ArcGisSectionalTitleColumn["PropertyDescription"] = "PropertyDescription";
    ArcGisSectionalTitleColumn["PortionNumber"] = "PtnNum";
    ArcGisSectionalTitleColumn["SGNumber"] = "SgCode";
    ArcGisSectionalTitleColumn["PremiseId"] = "PremiseID";
    ArcGisSectionalTitleColumn["AccountNumer"] = "AccountNo";
    ArcGisSectionalTitleColumn["SectionalTitleId"] = "SectionalTitleSchemeID";
    ArcGisSectionalTitleColumn["UnitNumber"] = "UnitNumber";
})(ArcGisSectionalTitleColumn || (ArcGisSectionalTitleColumn = {}));
export var ArcGisOwnerColumn;
(function (ArcGisOwnerColumn) {
    ArcGisOwnerColumn["OwnerId"] = "OBJECTID";
    ArcGisOwnerColumn["OwnerName"] = "Name";
    ArcGisOwnerColumn["OwnerSurname"] = "Surname";
    ArcGisOwnerColumn["OwnerOrganisation"] = "Organisation";
    ArcGisOwnerColumn["OwnerRepresentative"] = "Representative";
    ArcGisOwnerColumn["OwnerOrganisationRegNo"] = "OrganisationRegistrationNumber ";
    ArcGisOwnerColumn["OwnerIDNumber"] = "IDNumber";
    ArcGisOwnerColumn["SGNumber"] = "SgCode";
    ArcGisOwnerColumn["ErfNumber"] = "ErfNo";
    ArcGisOwnerColumn["FarmNumber"] = "FarmNo";
    ArcGisOwnerColumn["Address"] = "Address";
    ArcGisOwnerColumn["PropertyId"] = "Property_OBJECTID";
})(ArcGisOwnerColumn || (ArcGisOwnerColumn = {}));
export var ArcGisZoningColumn;
(function (ArcGisZoningColumn) {
    ArcGisZoningColumn["ZoningId"] = "OBJECTID";
    ArcGisZoningColumn["Zoning"] = "Zoning";
    ArcGisZoningColumn["SGNumber"] = "SgCode";
    ArcGisZoningColumn["ErfNumber"] = "ErfNo";
    ArcGisZoningColumn["Address"] = "Address";
    ArcGisZoningColumn["PropertyId"] = "Property_OBJECTID";
})(ArcGisZoningColumn || (ArcGisZoningColumn = {}));
